import React from 'react'
import { Wrapper } from './PublicationGrid.styles'
import { GridPublicationItemPlaceholder } from '../GridPublicationItem'

const PublicationGridPlaceholder = () => {
  return (
    <Wrapper>
      <GridPublicationItemPlaceholder />
      <GridPublicationItemPlaceholder />
      <GridPublicationItemPlaceholder />
      <GridPublicationItemPlaceholder />
    </Wrapper>
  )
}

export default PublicationGridPlaceholder
